import { CustomSelectFieldProps, SelectField } from 'components/form'
import { GrauParentescoEnum } from 'graphql/types.generated'
import { grauParentescoRecord } from 'types/enums'

export type GrauParentescoSelectFieldProps = Readonly<CustomSelectFieldProps<GrauParentescoEnum>>

export function GrauParentescoSelectField(props: GrauParentescoSelectFieldProps) {
  return <SelectField<GrauParentescoEnum> items={allItems} itemToString={itemToString} {...props} />
}

const allItems = Object.keys(grauParentescoRecord) as GrauParentescoEnum[]

const itemToString = (item: GrauParentescoEnum) => item && grauParentescoRecord[item]
